<fgb-account-panel
  *ngIf="member$ | async as member"
  class="account-details-panel"
  titleKey="account.my-details.title"
  titleDefault="My details"
>
  <ng-container *ngIf="isEditing; else readView">
    <fgb-edit-account-details [autoEditMode]="true" (actionDone)="onDetailsSaved()"></fgb-edit-account-details>
  </ng-container>

  <ng-template #readView>
    <div class="user-details">
      <div class="detail-list">
        <div class="detail-row">
          <span class="detail-row-label">{{ 'account.my-details.dob' | translate : { fgbdefault: 'Date of birth' } }}</span>
          <span class="detail-row-value">{{ member.DOB | date : 'd MMMM yyyy' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-row-label">{{
            'account.my-details.email' | translate : { fgbdefault: 'Email Address' }
          }}</span>
          <span class="detail-row-value">{{ member.EmailAddress1 }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-row-label">{{ 'account.my-details.address' | translate : { fgbdefault: 'Address' } }}</span>
          <span class="detail-row-value"
            >{{ member.Street }}, {{ member.Town }}, {{ member.County }}, {{ member.PostCode }}, {{ member.Country }}</span
          >
        </div>
      </div>

      <div class="my-details-actions read-actions">
        <button type="button" class="btn-filled-primary" (click)="edit()">
          {{ 'account.my-details.edit' | translate : { fgbdefault: 'Edit Details' } }}
        </button>
      </div>
    </div>
  </ng-template>
</fgb-account-panel>
